import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { configuration } from 'src/configuration';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';
@Component({
  selector: 'app-featured-properties',
  templateUrl: './featured-properties.component.html',
  styleUrls: ['./featured-properties.component.css']
})
export class FeaturedPropertiesComponent implements AfterViewInit, OnInit {
  propertyList: any = [];
  limit: any = configuration.PAGE_LIMIT;
  offset: any = configuration.OFFSET;

  constructor(public shared: SharedService, private elRef: ElementRef, private renderer: Renderer2, public apiService: ApiServiceService) {
  }

  ngOnInit(): void {
    this.renderer.listen('document', 'click', (event: Event) => {
      const target = event.target as HTMLElement;
      if (!this.elRef.nativeElement.contains(target)) {
        // this.isDropdownOpen = false;
        // this.isPriceLimitDropdownOpen = false;
      }
    });
    this.getPropertyList();
  }

  async getPropertyList() {
    const requestBody = {
      limit: this.limit,
      offset: this.offset,
      is_featured: true
    };
  
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.PROPERTY_LIST, requestBody);
  
    if (res && !res.error && res.data) {
      this.propertyList = res.data.rows;
    }
  }
  
  
  
  
  
  ngAfterViewInit(): void {
    this.shared.includeMainScript();
  }
}
